const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "CusCode",
		label: "客户编码",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "客户名称",
		columnwidth: 200,
	},
	// {
	// 	prop: "CusTypeName",
	// 	label: "客户类型",
	// 	columnwidth: 130,
	// },
	{
		prop: "IsProviderName",
		label: "仅授权不订货",
		columnwidth: 150,
	},
	{
		prop: "BOSSName",
		label: "公司负责人",
		columnwidth: 150,
	},
	{
		prop: "BOSSCustomer",
		label: "关联公司",
		columnwidth: 150,
	},
	{
		prop: "CusAbbName",
		label: "客户简称",
		columnwidth: 130,
	},
	{
		prop: "NoStockInAppName",
		label: "库存不展示",
		columnwidth: 130,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 130,
	},
	{
		prop: "CompanyName",
		label: "上游经销商名称",
		columnwidth: 280,
	},
	{
		prop: "CustomerProvince",
		label: "经营省份",
		columnwidth: 130,
	},
	{
		prop: "AreaMan",
		label: "小区经理",
		columnwidth: 150,
	},
	{
		prop: "HandAreaMan",
		label: "手工小区经理",
		columnwidth: 150,
	},
	{
		prop: "ProvinceMan",
		label: "省级经理",
		columnwidth: 100,
	},
	{
		prop: "HandProvinceMan",
		label: "手工省级经理",
		columnwidth: 100,
	},
	{
		prop: "CustomerProvinceCity",
		label: "经营城市",
		columnwidth: 100,
	},
	{
		prop: "Address",
		label: "详细地址",
		columnwidth: 150,
	},
	{
		prop: "LinkMan",
		label: "联系人",
		columnwidth: 100,
	},
	{
		prop: "LinkPhone",
		label: "联系方式",
		columnwidth: 130,
	},
	{
		prop: "BLBusinessStartDate",
		label: "营业执照有效起始日期", ///
		columnwidth: 120,
	},
	{
		prop: "BLBusinessEndDate",
		label: "营业执照终止日期", ///
		columnwidth: 120,
	},
	{
		prop: "LicenseNo",
		label: "经营许可证",
		columnwidth: 160,
	},
	{
		prop: "VoucherNo",
		label: "备案凭证编号",
		columnwidth: 160,
	},
	{
		prop: "VoucherMDate",
		label: "备案凭证有效起始日期",
		columnwidth: 160,
	},
	{
		prop: "LicenseMDate",
		label: "经营许可证有效起始日期",
		columnwidth: 160,
	},
	{
		prop: "LicenseVDate",
		label: "经营许可证有效结束日期",
		columnwidth: 130,
	},
	{
		prop: "VoucherVDate",
		label: "备案凭证有效结束日期",
		columnwidth: 160,
	},
	{
		prop: "CompanyInCharge",
		label: "企业负责人",
		columnwidth: 160,
	},
	{
		prop: "BusinessAddress",
		label: "经营地址",
		columnwidth: 160,
	},
	{
		prop: "CompanyInLaw",
		label: "法人代表",
		columnwidth: 160,
	},
	{
		prop: "WarehouseAddress",
		label: "仓库地址",
		columnwidth: 160,
	},
	{
		prop: "Password",
		label: "密码",
		columnwidth: 160,
	},
	{
		prop: "Actived",
		label: "是否启用",
		columnwidth: 160,
	},
	{
		prop: "CooperateStatusName",
		label: "合作状态",
		columnwidth: 160,
	},
	{
		prop: "UnVerifyLicenseCount",
		label: "未审批证照数量列",
		columnwidth: 130,
	},
	{
		prop: "Creator",
		label: "创建人",
		columnwidth: 90,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 160,
	},
	{
		prop: "Updater",
		label: "修改人",
		columnwidth: 90,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 160,
	},
	{
		prop: "Activor",
		label: "停启用人",
		columnwidth: 90,
	},
	{
		prop: "ActiveTime",
		label: "停启用时间",
		columnwidth: 160,
	},
];
export default headerData